import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  useTheme,
  useMediaQuery,
  Avatar,
} from "@mui/material";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";

const DRAWER_W = 260;

export default function Navbar({ onMenuClick }) {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"));
  const firstName = localStorage.getItem("firstName") || "U";

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        width: { md: `calc(100% - ${DRAWER_W}px)` },
        ml: { md: `${DRAWER_W}px` },
        bgcolor: "background.paper",
        borderBottom: "1px solid",
        borderColor: "divider",
      }}
    >
      <Toolbar sx={{ gap: 1 }}>
        {!isMd && (
          <IconButton onClick={onMenuClick} edge="start">
            <MenuRoundedIcon />
          </IconButton>
        )}
        <Typography
          variant="h6"
          sx={{ color: "text.primary", flexGrow: 1, fontSize: 18 }}
        >
          {getGreeting()}, {firstName}
        </Typography>
        <IconButton>
          <NotificationsNoneRoundedIcon sx={{ color: "text.secondary" }} />
        </IconButton>
        <Avatar
          sx={{
            bgcolor: "primary.main",
            width: 34,
            height: 34,
            fontSize: 14,
            fontWeight: 700,
          }}
        >
          {firstName[0]?.toUpperCase()}
        </Avatar>
      </Toolbar>
    </AppBar>
  );
}

function getGreeting() {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 17) return "Good afternoon";
  return "Good evening";
}
